/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_ExercisingInputs */

const en_homepage_listen_in_exercising = /** @type {(inputs: Homepage_Listen_In_ExercisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercising`)
};

const es_homepage_listen_in_exercising = /** @type {(inputs: Homepage_Listen_In_ExercisingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haciendo ejercicio`)
};

/**
* | output |
* | --- |
* | "Exercising" |
*
* @param {Homepage_Listen_In_ExercisingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_exercising = /** @type {((inputs?: Homepage_Listen_In_ExercisingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_ExercisingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_exercising(inputs)
	return en_homepage_listen_in_exercising(inputs)
});